import React, { useState } from 'react'
import {
    Box, Button, Dialog, DialogContent,
    Grid, FormControl, FormGroup, FormLabel, OutlinedInput, Typography
} from '@material-ui/core'
import AdminAPI from 'config/api/AdminAPI'
import Loader from 'components/general/Loader'
import { onError } from 'config/lib/errorLib'
import { NotificationManager } from 'react-notifications'
import { sendEeProviderAlert } from 'config/helpers/integrations-lib'
import { formatDomain } from 'config/helpers/Helpers'

function AddProviderModal({ open, onClose, onAdded }) {
    const api = new AdminAPI()

    const [name, setName] = useState('')
    const [url, setUrl] = useState('')
    const [loading, setLoading] = useState(false)

    const disabled = !name.trim() || !url.trim() || loading

    function reset() {
        setName('')
        setUrl('')
    }

    async function submit() {
        setLoading(true)
        try {
            const created = await api.addProvider(name.trim(), formatDomain(url.trim()))
            if (created && created.success === false) {
                NotificationManager.error(created.message || 'Failed to add provider')
            } else {
                NotificationManager.success('Provider added')
                sendEeProviderAlert({ type: 'provider_created', company: created })
                reset()
                onAdded && onAdded(created)
                onClose && onClose()
            }
        } catch (e) {
            onError(e)
        }
        setLoading(false)
    }

    function handleClose() {
        if (loading) return
        reset()
        onClose && onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box component={Typography} variant='h2' marginBottom='0.5rem'>
                            Add Provider
                        </Box>
                        <Typography variant='body2'>
                            Creates a provider record you can populate from the provider detail screen. You can invite an admin user from the provider profile when ready.
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Company Name</FormLabel>
                            <FormControl variant='filled' component={Box} width='100%'>
                                <OutlinedInput
                                    autoComplete='off'
                                    type='text'
                                    placeholder='e.g. Green Solar Solutions'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Website URL</FormLabel>
                            <FormControl variant='filled' component={Box} width='100%'>
                                <OutlinedInput
                                    autoComplete='off'
                                    type='text'
                                    placeholder='www.greensolar.ie'
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='flex-end' style={{ gap: '0.5rem' }}>
                            <Button variant='outlined' onClick={handleClose} disabled={loading}>
                                Cancel
                            </Button>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={submit}
                                disabled={disabled}
                            >
                                {!loading ? 'Create Provider' : <Loader height={12} />}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default AddProviderModal
